module.exports = __webpack_public_path__ + "media/images/city/100-big-ben-3c293ce5b02fece141254fc78fcdc229.svg";